import React, { useContext } from "react";
import DetailFrame from "./DetailFrame";
import Monitoring from "./Monitoring";
import { WithGrow } from "@common/components/WithGrow";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";

type DetailViewProps = {};

const DetailView = (props: DetailViewProps) => {
  const context = useContext(RoomsRealtimeContext);
  if (typeof context.detail === "undefined") return <></>;

  const detailCtx = { ...context.detail };

  return (
    <WithGrow direction="column" fixed={<Monitoring />}>
      <DetailFrame element={detailCtx.detailFrameRef} />
    </WithGrow>
  );
};

export default DetailView;
